export * from './Onboarding';

export const referralSourceOptions = [
  { label: 'Bing', value: 'Bing' },
  { label: 'ChatGPT', value: 'ChatGPT' },
  { label: 'Claude', value: 'Claude' },
  { label: 'Conference', value: 'Conference' },
  { label: 'Doximity', value: 'Doximity' },
  { label: 'EHR Marketplace', value: 'EHR Marketplace' },
  { label: 'Elion', value: 'Elion' },
  { label: 'Email', value: 'Email' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Fierce Healthcare', value: 'Fierce Healthcare' },
  { label: 'Forbes', value: 'Forbes' },
  { label: 'Fortune', value: 'Fortune' },
  { label: 'Gemini', value: 'Gemini' },
  { label: 'Google', value: 'Google' },
  { label: 'HIMSS', value: 'HIMSS' },
  { label: 'HIMSS Oregon', value: 'HIMSS Oregon' },
  { label: 'LinkedIn', value: 'LinkedIn' },
  { label: 'MGMA', value: 'MGMA' },
  { label: 'Perplexity', value: 'Perplexity' },
  { label: 'Podcast', value: 'Podcast' },
  { label: 'Print Ad', value: 'Print Ad' },
  { label: 'Reddit', value: 'Reddit' },
  { label: 'VentureBeat', value: 'VentureBeat' },
  { label: 'Webinar', value: 'Webinar' },
  { label: 'Word of mouth', value: 'Word of mouth' },
  { label: 'X (Twitter)', value: 'X (Twitter)' },
  { label: 'YouTube', value: 'YouTube' },
  { label: 'Other', value: 'Other' },
];

export const celloReferralSourceOption = {
  label: 'Existing user',
  value: 'Cello',
};
